export default __webpack_public_path__ + "eb3e0006f6635ebed2ed13b3fdc4fba8.svg";